import { createApi } from '@shared/redux/createApi';

const tags = {
  news: 'news',
};

const buildNewsFormData = async (data) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(data)) {
    if (value === undefined || value === null || value === '') {
      if (key === 'action_type' || key === 'action_url') {
        formData.append(key, 'none');
        continue;
      }
      continue;
    }

    if (key === 'image' && typeof value === 'string') {
      if (value.startsWith('data:')) {
        const res = await fetch(value);
        const blob = await res.blob();
        formData.append('image', blob, 'image.png');
      } else {
        // Existing URL — don't re-upload, skip the field
        continue;
      }
    } else {
      formData.append(key, value);
    }
  }

  return formData;
};

export const newsApi = createApi({
  reducerPath: 'newsApi',
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    getNewsList: builder.query({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `/news/list?page=${page}&limit=${limit}`,
        method: 'get',
      }),
      providesTags: [tags.news],
    }),
    createNews: builder.mutation({
      queryFn: async (data, _queryApi, _extraOptions, baseQuery) => {
        const formData = await buildNewsFormData(data);
        return baseQuery({ url: '/news/create', method: 'post', body: formData });
      },
      invalidatesTags: [tags.news],
    }),
    updateNews: builder.mutation({
      queryFn: async (data, _queryApi, _extraOptions, baseQuery) => {
        const formData = await buildNewsFormData(data);
        return baseQuery({ url: '/news/update', method: 'post', body: formData });
      },
      invalidatesTags: [tags.news],
    }),
    deleteNews: builder.mutation({
      query: (data) => ({
        url: '/news/delete',
        method: 'delete',
        body: data
      }),
      invalidatesTags: [tags.news],
    }),
  }),
});

export const {
  useGetNewsListQuery,
  useCreateNewsMutation,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
} = newsApi;
